function filterForm() {

	if ( $('.filter__form').length ) {

		// Current page
		let currPage = document.querySelector('input[name="current-page"]').value;

		// Form selectors
		const $filterForm = $('.filter__form');
		const $postList = document.querySelector('.post-list__inner');

		// Set form filters
		function setFilters() {
			for (const [key, value] of urlParams.entries()) {
				if (key === 'category') {
					checkboxes = value.split(',');
					checkboxes.forEach(function (v) {
						document.querySelector('input[value=' + v + ']').checked = 'true';
					});
				} else {
					document.getElementsByName(key).forEach(p => p.value = value);
				}
			}
		}
		//setFilters();

		// Build query string
		function makeQueryString() {
			const selectedCategories = Array.from(document.querySelectorAll('input[name="category[]"]:checked')).map(checkbox => checkbox.value);

			const urlParams = new URLSearchParams();
			urlParams.append('category', selectedCategories.join(','));

			let keysForDel = [];
			urlParams.forEach((v, k) => {
				if (v === '' || v === undefined)
					keysForDel.push(k);
			});
			keysForDel.forEach(k => {
				urlParams.delete(k);
			});

			if (location.search) {
				history.pushState({}, null, location.href.replace(location.search, '?' + urlParams));
			} else {
				history.pushState({}, null, location.href.replace(location.href, '?' + urlParams));
			}
		}

		// Filter changes
		let filterTimeout = null;
		$('.filter__form input[type="checkbox"]').change(function() {
			if ($(this).attr('id') == 'all-categories' && $(this).is(':checked')) {
				$('.filter__form input[type="checkbox"]').not('#all-categories').prop('checked', false);
			} else if ($('[name="category[]"]:checked').not('#all-categories').length > 0) {
				$('#all-categories').prop('checked', false);
			} else {
				$('#all-categories').prop('checked', true);
			}

			if (filterTimeout) {
				clearTimeout(filterTimeout);
			}
			
			filterTimeout = setTimeout(function() {
				$filterForm.submit();
			}, 500);
		});

		$filterForm.submit(function (e) {
			e.preventDefault();

			// Reset current page
			currPage = 1;
			document.querySelector('input[name="current-page"]').value = currPage;

			// Make query
			makeQueryString();
			filterPosts(false);
		});

		function filterPosts(loadMore) {
			let formData = $filterForm.serializeArray();
			formData.push({ name: 'action', value: 'filter_posts' });
			formData.push({ name: 'load-more', value: loadMore });
			if (loadMore) {
				$('.load-more').addClass('is--loading');
			}

			let lastPost = $('.post-list__inner article').last().attr('id');

			$.ajax({
				type: 'POST',
				url: theme_vars.ajax_url,
				async: false,
				dataType: 'json',
				data: formData,
				success: function(resp) {
					let postTotal = resp.total,
						pageTotal = resp.pages;

					// Populate list
					if (resp.load_more == 'true') {
						$postList.innerHTML = $postList.innerHTML + resp.posts;

						// Focus last post before load more
						$('a', $('#'+lastPost)).focus();
						$('a', $('#'+lastPost)).blur();
					} else {
						$postList.innerHTML = resp.posts;
					}

					// Show/Hide load more
					if (currPage == pageTotal || postTotal == 0) {
						$('.post-list__footer').hide();
					} else {
						$('.post-list__footer').show();
					}

					// Scroll to top of results list on filter change
					// if (window.matchMedia('(max-width: 991px)').matches && !loadMore) {
					// 	let offset = 0;
					// 	$('html, body').animate({
					// 		scrollTop: $('.post-list__inner').offset().top - offset
					// 	}, 1000);
					// }

					// Remove loading class from button
					$('.load-more').removeClass('is--loading');
				}
			});
		}

		// Accessibility
		$('.filter__form label').on('keypress', function (event) {
			if (event.which === 13) {
				$(this).find('input').prop('checked', !$(this).find('input').prop('checked')).change();
			}
		});

		// Load More
		$('.load-more').click(function(e) {
			e.preventDefault();
			currPage++;
			document.querySelector('input[name="current-page"]').value = currPage;
			makeQueryString();
			filterPosts(true);
		});
		
	}
}